module.exports = __webpack_public_path__ + "static/carrion_crawler-a793f94e5de7c893a8f31a0ad45e64a6.jpg";